import React from 'react';

function StrongList({ listParts }) {
    return listParts.map(({ type, value }, index) =>
        type === 'element' ? <strong key={`${value}-${index}`}>{value}</strong> : value
    );
}

export default StrongList;
